import { RouteRecordRaw } from 'vue-router';

const resourcesRoutes: RouteRecordRaw[] = [
  // {
  //   path: '/resources/news',
  //   name: 'resources-news',
  //   component: () => import(/* webpackChunkName: "resources-news" */ '@/views/resources/NewsView.vue'),
  //   meta: {
  //     title: 'News',
  //     requiresAuth: false,
  //   },
  // },
  // {
  //   path: '/resources/blog',
  //   name: 'resources-blog',
  //   component: () => import(/* webpackChunkName: "resources-blog" */ '@/views/resources/BlogView.vue'),
  //   meta: {
  //     title: 'Blog',
  //     requiresAuth: false,
  //   },
  // },
];

export default resourcesRoutes;